import { Question } from '../types/form';

export const questions: Question[] = [
  {
    id: 'motivo',
    eyebrow: 'Pergunta 01',
    title: 'Qual é o principal motivo da sua busca?',
    helper: 'Escolha o que mais incomoda hoje.',
    layout: 'image',
    options: [
      {
        id: 'lombar',
        label: 'Dor lombar ou nas costas',
        image:
          'https://cdn.magicpatterns.com/patterns/generated-images/f0334570-eb35-42a3-a133-0e662b0445a2.jpg',
      },
      {
        id: 'cervical',
        label: 'Dor no pescoço ou cervical',
        image:
          'https://cdn.magicpatterns.com/patterns/generated-images/fbebb5ee-76c4-4275-adb9-f25c413c1596.jpg',
      },
      {
        id: 'ciatica',
        label: 'Dor ciática, formigamento ou dor irradiada',
        image:
          'https://cdn.magicpatterns.com/patterns/generated-images/b3692009-fec2-4318-b74a-017ac808614c.jpg',
      },
      {
        id: 'travamento',
        label: 'Travamento ou dificuldade de movimento',
        image:
          'https://cdn.magicpatterns.com/patterns/generated-images/33848bd9-615e-424a-982b-998ab934affc.jpg',
      },
      {
        id: 'outros',
        label: 'Outros',
        detail: 'Conte com suas palavras',
        isOther: true,
        image:
          'https://cdn.magicpatterns.com/patterns/generated-images/6f3c0b7f-96c3-422b-8098-baf897bf4787.jpg',
      },
    ],
  },
  {
    id: 'tempo',
    eyebrow: 'Pergunta 02',
    title: 'Há quanto tempo você sente esse desconforto?',
    helper: 'O tempo de história muda bastante o plano de cuidado.',
    layout: 'timeline',
    options: [
      { id: 'dias', label: 'Há poucos dias', detail: 'Quadro recente' },
      { id: 'semanas', label: 'Há algumas semanas', detail: 'Começando a persistir' },
      { id: '1a6', label: 'Entre 1 e 6 meses', detail: 'Já se tornou rotina' },
      { id: 'mais6', label: 'Há mais de 6 meses', detail: 'Quadro crônico' },
      { id: 'outros', label: 'Outros', isOther: true },
    ],
  },
  {
    id: 'rotina',
    eyebrow: 'Pergunta 03',
    title: 'Quanto isso interfere na sua rotina hoje?',
    helper: 'Pense no trabalho, no sono e nas atividades que você gosta.',
    layout: 'scale',
    options: [
      { id: 'quase-nao', label: 'Quase não interfere' },
      { id: 'pouco', label: 'Interfere pouco' },
      { id: 'moderado', label: 'Interfere moderadamente' },
      { id: 'bastante', label: 'Interfere bastante' },
      { id: 'outros', label: 'Outros', isOther: true },
    ],
  },
  {
    id: 'sinais',
    eyebrow: 'Pergunta 04',
    title: 'Você percebe algum destes sinais junto com o desconforto?',
    helper: 'Pode marcar mais de uma opção.',
    multi: true,
    layout: 'image',
    options: [
      {
        id: 'formigamento',
        label: 'Formigamento ou dormência',
        image:
          'https://cdn.magicpatterns.com/patterns/generated-images/cee7aaef-2686-4c59-b3db-49206b2df112.jpg',
      },
      {
        id: 'rigidez',
        label: 'Rigidez',
        image:
          'https://cdn.magicpatterns.com/patterns/generated-images/50be817c-97bc-4302-a87e-5f02693aeeeb.jpg',
      },
      {
        id: 'dor-movimento',
        label: 'Dor ao se movimentar',
        image:
          'https://cdn.magicpatterns.com/patterns/generated-images/42a2dc7d-c793-4874-a60b-3034f8befd84.jpg',
      },
      {
        id: 'limitacao',
        label: 'Limitação de movimento',
        image:
          'https://cdn.magicpatterns.com/patterns/generated-images/d9774a5a-da90-46a6-a7a7-e27bf2a1659f.jpg',
      },
      {
        id: 'outros',
        label: 'Outros',
        detail: 'Descreva o que sente',
        isOther: true,
        image:
          'https://cdn.magicpatterns.com/patterns/generated-images/6f3c0b7f-96c3-422b-8098-baf897bf4787.jpg',
      },
    ],
  },
  {
    id: 'historico',
    eyebrow: 'Pergunta 05',
    title: 'Você já buscou algum atendimento para esse problema?',
    layout: 'image',
    options: [
      {
        id: 'primeira',
        label: 'Não, será minha primeira avaliação',
        image:
          'https://cdn.magicpatterns.com/patterns/generated-images/2724227c-7856-475f-9a51-a4cdbc515a1b.jpg',
      },
      {
        id: 'fisio',
        label: 'Já fiz fisioterapia',
        image:
          'https://cdn.magicpatterns.com/patterns/generated-images/24cc603c-b9c6-44b4-8f3e-296d0bdc15ef.jpg',
      },
      {
        id: 'quiro',
        label: 'Já passei por quiropraxia',
        image:
          'https://cdn.magicpatterns.com/patterns/generated-images/1291e931-bc31-46da-a283-a94f8fc7f48e.jpg',
      },
      {
        id: 'medico',
        label: 'Já consultei médico ou fiz exames',
        image:
          'https://cdn.magicpatterns.com/patterns/generated-images/63754a8e-7380-455e-8123-f46fe36c9017.jpg',
      },
      {
        id: 'outros',
        label: 'Outros',
        detail: 'Conte o que já tentou',
        isOther: true,
        image:
          'https://cdn.magicpatterns.com/patterns/generated-images/6f3c0b7f-96c3-422b-8098-baf897bf4787.jpg',
      },
    ],
  },
];
